import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';

import {
  startAddBidLabor,
  startAddBidMaterials,
  startEditBidLabor,
  startEditBidMaterials
} from '../../../../store/actions/bids';

import {
  startEditProjectLabor,
} from '../../../../store/actions/projectTasks';

const styles = theme => ({
  root: {
  },
  description: {
    flexGrow: 1,
    marginBottom: theme.spacing.unit*2,
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  quanitity: {
    marginRight: theme.spacing.unit*2,
  },
  price: {
    marginLeft: theme.spacing.unit*2,
  },
});

const DEFAULT_STATE = {
  id: "",
  description: "",
  quantity: 0,
  rate: 0,
}

class TaskItem extends Component {
  constructor(props){
    super(props);

    this.state = DEFAULT_STATE;
  }


  //TODO: only handle set state when nextProps changes
  componentWillReceiveProps(nextProps) {
    const item = nextProps.item;
    if (item === undefined) {
      this.setState(DEFAULT_STATE)
    } else {
      this.setState({
        id: item.id,
        description: item.description,
        quantity: item.quantity,
        rate: item.rate
      });
    }
  }

  handleChange = propertyName => event => {
    this.setState({
      [propertyName]: event.target.value,
    });
  };

  actionFactory = () => {
    const {
      item,
      type,
      startAddBidLabor,
      startAddBidMaterials,
      startEditBidMaterials,
      startEditProjectLabor,
    } = this.props;

    if (type.toLowerCase() === "labor") {
      if (item === undefined) {
        return startAddBidLabor;
      } else {
        return startEditProjectLabor;
      }
    } else {
      if (item === undefined) {
        return startAddBidMaterials;
      } else {
        return startEditBidMaterials;
      }
    }
  }

  render() {
    const {
      classes,
      projectTask,
      showItem,
      handleClose,
    } = this.props;

    const startAction = this.actionFactory();

    let title = "";
    if (showItem !== undefined) {
      title = showItem === "add" ? "Add Item" : "Edit Item";
    }

    return (
      <Dialog
        open={showItem !== undefined ? true : false}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        className={classes.root}
      >
        <DialogTitle id="form-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <TextField
            className={classes.description}
            autoFocus
            multiline={true}
            margin="dense"
            id="description"
            label="Description"
            type="text"
            value={this.state.description}
            onChange={this.handleChange("description")}
            fullWidth
          />
          <div className={classes.row}>
            <TextField
              className={classes.quantity}
              margin="dense"
              id="quantity"
              label="Quantity"
              type="number"
              value={this.state.quantity}
              onChange={this.handleChange("quantity")}
              fullWidth
            />

            <TextField
              className={classes.price}
              margin="dense"
              id="unitPrice"
              label="Unit Price"
              type="number"
              value={this.state.rate}
              onChange={this.handleChange("rate")}
              fullWidth
            />
          </div>

        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={handleClose} >
            Cancel
          </Button>
          <Button color="primary" onClick={() => {
              //TODO: refactor as this code sucks
              if (showItem === "add") {
                const payload = {
                  description: this.state.description,
                  quantity: Number(this.state.quantity),
                  rate: Number(this.state.rate)
                };
                startAction(projectTask.id, payload);
              } else {
                const payload = {
                  description: this.state.description,
                  quantity: Number(this.state.quantity),
                  rate: Number(this.state.rate)
                }
                startAction(projectTask.id, this.state.id, payload);
              }
              this.setState(DEFAULT_STATE);
              handleClose();
            }} >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
const mapDispatchToProps = (dispatch) => ({
  startAddBidLabor: (bidTaskId, bidLabor) => dispatch(startAddBidLabor(bidTaskId, bidLabor)),
  startAddBidMaterials: (bidTaskId, bidMaterials) => dispatch(startAddBidMaterials(bidTaskId, bidMaterials)),
  startEditBidLabor: (bidTaskId, bidLaborId, updates) => dispatch(startEditBidLabor(bidTaskId, bidLaborId, updates)),
  startEditBidMaterials: (bidTaskId, bidMaterialsId, updates) => dispatch(startEditBidMaterials(bidTaskId, bidMaterialsId, updates)),
  startEditProjectLabor: (projectTaskId, laborId, updates) => dispatch(startEditProjectLabor(projectTaskId, laborId, updates)),
});

export default compose(
  withStyles(styles),
  connect(null, mapDispatchToProps)
)(TaskItem);



// WEBPACK FOOTER //
// ./src/components/admin/Jobs/Tasks/TaskItem.jsx